/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "magnifying-glass-79fdcba4--sprite",
  "use": "magnifying-glass-79fdcba4--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"magnifying-glass-79fdcba4--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(-545.367 -4604.203)\"><path d=\"M564.64,4613.2a7.971,7.971,0,0,0-6.3,12.48l-3.68,3.68a1.009,1.009,0,0,0,0,1.42,1.025,1.025,0,0,0,.71.29,1.043,1.043,0,0,0,.71-.29l3.61-3.61a7.414,7.414,0,0,0,10.32-.46,7.7,7.7,0,0,0,2.23-5.49A7.822,7.822,0,0,0,564.64,4613.2Zm4.04,12.2a5.737,5.737,0,0,1-9.87-4.32v-.03a5.784,5.784,0,1,1,9.87,4.35Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
